
// import React from "react";
// import { Grid, Typography, Box } from "@mui/material";
// //prettier-ignore
// import { coordinateStyle, greenBorderWithCenterContent, greenBorderOnly, alignContentToCenterVertically, } from "./PlanPrintStyles";
// import { fromLonLat } from "ol/proj";

// // Helper component for common box structure
// const InfoBox = ({ title, content, variant = "body2", isBold = false, underline = false, textColor = "black" }) => (
//   <Box>
//     <Typography variant={variant} sx={{ fontWeight: isBold ? "bold" : "normal" }} color={textColor}>
//       {title}
//       {underline && (
//         <Typography sx={{ textDecoration: "underline" }} display="inline" color={textColor}>
//           {content}
//         </Typography>
//       )}
//       {!underline && content}
//     </Typography>
//   </Box>
// );

// // Function to cluster points into N groups and return centroids
// const clusterPointsToCentroids = (points, targetClusters = 8) => {
//   if (!points || points.length === 0) return [];
  
//   // Remove the last point if it's the same as the first (closed polygon)
//   let processedPoints = [...points];
//   if (processedPoints.length > 1 && 
//       processedPoints[0][0] === processedPoints[processedPoints.length - 1][0] && 
//       processedPoints[0][1] === processedPoints[processedPoints.length - 1][1]) {
//     processedPoints = processedPoints.slice(0, -1);
//   }
  
//   const numPoints = processedPoints.length;
  
//   // If we have exactly targetClusters points, return them
//   if (numPoints === targetClusters) return processedPoints;
  
//   // If we have fewer than targetClusters points, return all points
//   if (numPoints < targetClusters) return processedPoints;
  
//   // K-means clustering algorithm
//   let centroids = [];
//   const step = (numPoints - 1) / (targetClusters - 1);
//   for (let i = 0; i < targetClusters; i++) {
//     const index = Math.round(i * step);
//     centroids.push([...processedPoints[Math.min(index, numPoints - 1)]]);
//   }
  
//   const maxIterations = 100;
  
//   for (let iteration = 0; iteration < maxIterations; iteration++) {
//     const clusters = new Array(targetClusters).fill().map(() => []);
    
//     for (let i = 0; i < numPoints; i++) {
//       const point = processedPoints[i];
//       let minDistance = Infinity;
//       let closestCentroid = 0;
      
//       for (let j = 0; j < targetClusters; j++) {
//         const distance = Math.sqrt(
//           Math.pow(point[0] - centroids[j][0], 2) + 
//           Math.pow(point[1] - centroids[j][1], 2)
//         );
//         if (distance < minDistance) {
//           minDistance = distance;
//           closestCentroid = j;
//         }
//       }
//       clusters[closestCentroid].push(point);
//     }
    
//     let changed = false;
//     const newCentroids = [];
    
//     for (let j = 0; j < targetClusters; j++) {
//       if (clusters[j].length === 0) {
//         newCentroids.push([...centroids[j]]);
//         continue;
//       }
      
//       const sumX = clusters[j].reduce((sum, p) => sum + p[0], 0);
//       const sumY = clusters[j].reduce((sum, p) => sum + p[1], 0);
//       const centroidX = sumX / clusters[j].length;
//       const centroidY = sumY / clusters[j].length;
      
//       newCentroids.push([centroidX, centroidY]);
      
//       if (Math.abs(centroidX - centroids[j][0]) > 0.0001 || 
//           Math.abs(centroidY - centroids[j][1]) > 0.0001) {
//         changed = true;
//       }
//     }
    
//     centroids = newCentroids;
//     if (!changed) break;
//   }
  
//   return centroids;
// };

// // Function to cluster points along the path (preserves order)
// const clusterAlongPath = (points, targetClusters = 8) => {
//   if (!points || points.length === 0) return [];
  
//   let processedPoints = [...points];
//   if (processedPoints.length > 1 && 
//       processedPoints[0][0] === processedPoints[processedPoints.length - 1][0] && 
//       processedPoints[0][1] === processedPoints[processedPoints.length - 1][1]) {
//     processedPoints = processedPoints.slice(0, -1);
//   }
  
//   const numPoints = processedPoints.length;
  
//   if (numPoints <= targetClusters) return processedPoints;
  
//   // Divide points into segments and take centroid of each segment
//   const segmentSize = numPoints / targetClusters;
//   const centroids = [];
  
//   for (let i = 0; i < targetClusters; i++) {
//     const startIdx = Math.floor(i * segmentSize);
//     const endIdx = Math.floor((i + 1) * segmentSize);
//     const segmentPoints = processedPoints.slice(startIdx, endIdx);
    
//     if (segmentPoints.length > 0) {
//       const avgX = segmentPoints.reduce((sum, p) => sum + p[0], 0) / segmentPoints.length;
//       const avgY = segmentPoints.reduce((sum, p) => sum + p[1], 0) / segmentPoints.length;
//       centroids.push([avgX, avgY]);
//     }
//   }
  
//   return centroids;
// };

// // Function to extract coordinates safely
// const extractCoordinates = (feature) => {
//   try {
//     // Try different possible coordinate structures
//     let coords = [];
    
//     if (feature?.geometry?.coordinates) {
//       const geomCoords = feature.geometry.coordinates;
      
//       // Check if it's a Polygon (array of rings)
//       if (Array.isArray(geomCoords) && geomCoords.length > 0) {
//         // Get the first ring (exterior boundary)
//         const firstRing = geomCoords[0];
//         if (Array.isArray(firstRing) && firstRing.length > 0) {
//           coords = firstRing;
//         }
//       }
//       // Check if it's a MultiPolygon
//       else if (Array.isArray(geomCoords) && geomCoords[0] && Array.isArray(geomCoords[0][0])) {
//         coords = geomCoords[0][0];
//       }
//     }
    
//     // If we got coordinates, process them
//     if (coords.length > 0) {
//       // Ensure coordinates are in [lng, lat] format
//       return coords.map(coord => {
//         if (Array.isArray(coord) && coord.length >= 2) {
//           return [coord[0], coord[1]];
//         }
//         return null;
//       }).filter(coord => coord !== null);
//     }
    
//     return [];
//   } catch (error) {
//     console.error("Error extracting coordinates:", error);
//     return [];
//   }
// };

// // Main function to process coordinates
// const processCoordinates = (coordinates) => {
//   if (!coordinates || coordinates.length === 0) return [];
  
//   console.log("Processing coordinates:", coordinates.length, "points");
  
//   // If we have 8 or fewer points, return all points
//   if (coordinates.length <= 8) {
//     console.log("Returning all", coordinates.length, "points");
//     return coordinates;
//   }
  
//   // For more than 8 points, cluster into 8 groups
//   console.log("Clustering", coordinates.length, "points into 8 groups");
//   const clusteredPoints = clusterAlongPath(coordinates, 8);
//   console.log("Clustered into", clusteredPoints.length, "points");
  
//   return clusteredPoints;
// };

// // Helper for coordinate list with clustering
// const CoordinateList = ({ coordinates }) => {
//   if (!coordinates || coordinates.length === 0) {
//     return (
//       <Typography variant="body2" sx={{ fontSize: "10px", color: "gray" }}>
//         No coordinates available
//       </Typography>
//     );
//   }
  
//   // Process coordinates - cluster if more than 8
//   const processedCoordinates = processCoordinates(coordinates);
//   const originalCount = coordinates.length;
  
//   return (
//     <>
//       {processedCoordinates.map((coord, index) => {
//         try {
//           // Validate coordinate before conversion
//           if (!coord || coord.length < 2 || isNaN(coord[0]) || isNaN(coord[1])) {
//             console.warn("Invalid coordinate at index", index, coord);
//             return null;
//           }
          
//           const converted = fromLonLat(coord);
          
//           // Check if conversion was successful
//           if (isNaN(converted[0]) || isNaN(converted[1])) {
//             console.warn("Conversion failed for coordinate", coord);
//             return (
//               <Typography key={index} variant="body2" sx={{ fontSize: "10px", color: "red" }}>
//                 {index + 1}: Invalid coordinate
//               </Typography>
//             );
//           }
          
//           return (
//             <Typography key={index} variant="body2" sx={{ fontSize: "10px", color: "black" }}>
//               {index + 1}: X={parseFloat(converted[0]).toFixed(4)}, Y={parseFloat(converted[1]).toFixed(4)}
//             </Typography>
//           );
//         } catch (error) {
//           console.error("Error processing coordinate:", error, coord);
//           return (
//             <Typography key={index} variant="body2" sx={{ fontSize: "10px", color: "red" }}>
//               {index + 1}: Error processing coordinate
//             </Typography>
//           );
//         }
//       }).filter(item => item !== null)}
      
//       {originalCount > 8 && (
//         <Typography variant="caption" sx={{ fontSize: "8px", color: "gray", mt: 0.5, display: "block" }}>
//           (Clustered {originalCount} points into {processedCoordinates.length} centroids)
//         </Typography>
//       )}
//     </>
//   );
// };

// export const LeftTitleLegendAndCoordinates = ({ selectedPark, feature, companyName }) => {
//   const { address, name } = selectedPark || {};
  
//   // Extract coordinates safely from the feature
//   const coordinates = extractCoordinates(feature);
  
//   // Debug logging
//   console.log("Feature structure:", feature);
//   console.log("Extracted coordinates:", coordinates.length, "points");
//   if (coordinates.length > 0) {
//     console.log("First coordinate:", coordinates[0]);
//     console.log("Last coordinate:", coordinates[coordinates.length - 1]);
//   }

//   return (
//     <>
//       <Grid container sx={{ height: "25%" }}>
//         <Grid
//           item
//           xs={12}
//           sx={{
//             ...greenBorderWithCenterContent,
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "space-between",
//             alignItems: "center",
//           }}
//         >
//           <InfoBox title="LOCATION REGION - " content={address?.toUpperCase() || "Not Stated"} isBold />
//           <InfoBox title="NAME: " content={name?.toUpperCase() || "Not Stated"} underline textColor="green" />
//           <InfoBox title={companyName} isBold />
//         </Grid>
//       </Grid>
//       <Grid container sx={{ height: "75%" }}>
//         <Grid container sx={{ ...greenBorderOnly, marginTop: 1, py: 1 }}>
//           <Grid item xs={5} sx={{ ...alignContentToCenterVertically, borderRight: "1px solid grey" }}>
//             <InfoBox title="N" variant="h3" isBold />
//             <InfoBox title="LEGEND" isBold />            
//             <InfoBox title={
//               <> 
//                 <span style={{ 
//                   display: 'inline-block', 
//                   width: '10px', 
//                   height: '10px', 
//                   border: '2px solid #5E67AF',
//                   marginRight: '5px' 
//                 }}></span>
//                 {companyName}
//               </>
//             } />
//             <InfoBox title="UPIN " content={feature?.upin} isBold underline />
//           </Grid>
//           <Grid item xs={7} sx={{ ...coordinateStyle, gap: 1, paddingY: 1 }}>
//             <InfoBox title="COORDINATE" isBold />
//             <Box>
//               <CoordinateList coordinates={coordinates} />
//             </Box>
//           </Grid>
//         </Grid>
//       </Grid>
//     </>
//   );
// };

import React from "react";
import { Grid, Typography, Box } from "@mui/material";
//prettier-ignore
import { coordinateStyle, greenBorderWithCenterContent, greenBorderOnly, alignContentToCenterVertically, } from "./PlanPrintStyles";
import { fromLonLat } from "ol/proj";

// Helper component for common box structure
const InfoBox = ({ title, content, variant = "body2", isBold = false, underline = false, textColor = "black" }) => (
  <Box>
    <Typography variant={variant} sx={{ fontWeight: isBold ? "bold" : "normal" }} color={textColor}>
      {title}
      {underline && (
        <Typography sx={{ textDecoration: "underline" }} display="inline" color={textColor}>
          {content}
        </Typography>
      )}
      {!underline && content}
    </Typography>
  </Box>
);

// Helper for coordinate list
const CoordinateList = ({ coordinates }) =>
  coordinates.map((coord, index) => {
    const converted = fromLonLat(coord);
    return (
      <Typography key={index} variant="body2" sx={{ fontSize: "10px", color: "black" }}>
        {index + 1}: X={parseFloat(converted[0])?.toFixed(4)}, Y={parseFloat(converted[1])?.toFixed(4)}
      </Typography>
    );
  });

export const LeftTitleLegendAndCoordinates2 = ({ selectedPark, feature, companyName }) => {

  const { address, name } = selectedPark|| {};
  const coordinates = feature?.geometry?.coordinates?.[0][0] || [];
  const sorted = [...coordinates].sort((a, b) => a[0] - b[0]);
  console.log("COOCCCCOOOCOOCC", selectedPark)
  // Function to get coordinates to display (either original or clustered)
  const getCoordinatesToDisplay = () => {
    // If dataset has 8 or fewer points, use original coordinates
    if (sorted.length <= 8) {
      console.log("Using original coordinates (8 or fewer points):", sorted.length);
      return sorted;
    }
    
    // If dataset has more than 8 points, cluster into 8 groups
    console.log("Clustering dataset with", sorted.length, "points into 8 groups");
    
    const clusterCount = 8;
    const clusterSize = Math.ceil(sorted.length / clusterCount);
    const clusters = [];

    // Split into groups and calculate average for each group
    for (let i = 0; i < clusterCount; i++) {
      const start = i * clusterSize;
      const end = Math.min(start + clusterSize, sorted.length);
      
      if (start >= sorted.length) break;
      
      // Get points in this cluster
      const clusterPoints = sorted.slice(start, end);
      
      // Calculate average (centroid) of the cluster
      const avgX = clusterPoints.reduce((sum, point) => sum + point[0], 0) / clusterPoints.length;
      const avgY = clusterPoints.reduce((sum, point) => sum + point[1], 0) / clusterPoints.length;
      
      clusters.push({
        group: i + 1,
        centroid: [avgX, avgY],
        count: clusterPoints.length
      });
    }
    
    console.log("Clusters created:", clusters.length);
    return clusters.map(cluster => cluster.centroid);
  };

  const coordinatesToDisplay = getCoordinatesToDisplay();
  console.log("Coordinates to display:", coordinatesToDisplay.length);

  return (
    <>
      <Grid container sx={{ height: "25%" }}>
        <Grid
          item
          xs={12}
          sx={{
            ...greenBorderWithCenterContent,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <InfoBox title="LOCATION REGION - " content={address?.toUpperCase() || "Not Stated"} isBold />
          <InfoBox title="NAME: " content={selectedPark?.name?.toUpperCase() || "Not Stated"} underline textColor="green" />
          <InfoBox title={companyName} isBold />
        </Grid>
      </Grid>
      <Grid container sx={{ height: "75%" }}>
        <Grid container sx={{ ...greenBorderOnly, marginTop: 1 , py: 1}}>
          <Grid item xs={5} sx={{ ...alignContentToCenterVertically, borderRight: "1px solid grey" }}>
            <InfoBox title="N" variant="h3" isBold />
            <InfoBox title="LEGEND" isBold />            
            <InfoBox title={<> <span style={{ 
          display: 'inline-block', 
          width: '10px', 
          height: '10px', 
          border: '2px solid #5E67AF',
          marginRight: '5px' 
        }}></span>{companyName}</>} />
            <InfoBox title="UPIN " content={feature?.upin} isBold underline />
          </Grid>
          <Grid item xs={7} sx={{ ...coordinateStyle, gap: 1, paddingY: 1 }}>
            <InfoBox title="COORDINATE" isBold />
            <Box>
              {coordinatesToDisplay.length > 0 && (
                <>
                  {sorted.length > 8 && (
                    <Typography variant="caption" sx={{ fontSize: "8px", color: "gray", display: "block", mb: 1 }}>
                     
                    </Typography>
                  )}
                  <CoordinateList coordinates={coordinatesToDisplay} />
                </>
              )}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};